import { registerDefaultsForModule, ComposedTheme } from '@glu/theming';

// eslint-disable-next-line import/prefer-default-export
export const theme = ({ palette, typography }: ComposedTheme) => ({
  border: {
    // @theming labelText: Border color, type: color
    color: palette.accent,
  },
  checkbox: {
    // @theming labelText: Checkbox selected color, type: color
    selectedColor: palette.primary.normal,
  },
  row: {
    // @theming labelText: Row background color, type: color
    backgroundColor: palette.background,
    // @theming labelText: Row hover color, type: color
    hoverColor: palette.highlightBackground,
    text: {
      font: {
        // Spread - to be individual items: GLU-7505
        ...typography.text,
        // @theming labelText: Row text font size, type: pixel
        fontSize: '14px',
      },
      // @theming labelText: Row text color, type: color, backgroundColor: grid.row.backgroundColor
      color: palette.text.dark,
    },
  },
  header: {
    // @theming labelText: Header background color, type: color
    backgroundColor: palette.background,
    // @theming labelText: Header cell hover color, type: color
    hoverColor: palette.highlightBackground,
    text: {
      // Spread - to be individual items: GLU-7505
      font: typography.label,
      // @theming labelText: Header text color, type: color, backgroundColor: grid.header.backgroundColor
      color: palette.text.dark,
    },
  },
  separator: {
    color: palette.accent,
  },
});

registerDefaultsForModule('grid', theme);
